import axios from 'axios';
import { PROXY_PREFIX } from '../common/api';

const formId = window.formId;
const path = window.location.pathname.substring(1);
const appId = '#rwleadsl-app';
const slashIndex = path.indexOf('/');
const sessionId = new Date().getTime();
let firstPathSegment = '';
firstPathSegment = slashIndex != -1 ? `/${path.substring(0, slashIndex)}` : firstPathSegment;

export default {
	methods: {
		formApiUrl() {
			return `${firstPathSegment}${PROXY_PREFIX}/requests/forms/${formId}/sessions/${sessionId}/complete`;
		},
		onRecaptchaVerify(token) {
			this.token = token;
		},
		resetRecaptcha() {
			this.$refs.recaptcha.reset();
		},
		submit() {
			this.submitForm();
		},
		submitForm() {
			if (!this.formState.$invalid) {
				this.isSubmitting = true;
				let formData = this.model;

				if (this.token) {
					formData.recaptcha = this.token;
				}

				for (const key in formData) {
					if (formData[key].services && Array.isArray(formData[key].services) && formData[key].services.length) {
						formData[key].services = Object.assign({}, formData[key].services);
					} else if (formData[key].services && Array.isArray(formData[key].services) && !formData[key].services.length) {
						formData[key].services = null;
					}
				}

				axios
					.post(this.formApiUrl(), { 1: this.model })
					.then((response) => {
						if (response.data.status == 'OK') {
							this.submited = true;
							this.scrollToElement(appId);
						} else if (response.data['1']) {
							this.validate(response.data);
							this.scrollToElement(appId);
						}
					})
					.catch(() => {
						this.submitError = true;
						this.scrollToElement(appId);
					})
					.finally(() => {
						this.isSubmitting = false;
						if (this.$refs.recaptcha) {
							this.resetRecaptcha();
						}
					});
			}
		},
		scrollToElement(element) {
			setTimeout(() => {
				this.$scrollTo(element);
			}, 0);
		}
	}
};
